export const PICKUP_RADIUS_M = 350;
export const DROP_RADIUS_M = 150;

const EARTH_RADIUS_M = 6371000;
const toRadians = (degrees) => (degrees * Math.PI) / 180;

const toNumber = (value) => (value === null || value === undefined || `${value}`.trim() === "" ? NaN : Number(value));

export const toPoint = (latitude, longitude) => {
  const lat = toNumber(latitude);
  const lng = toNumber(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  if (lat === 0 && lng === 0) return null;
  return { latitude: lat, longitude: lng };
};

export const distanceMetres = (from, to) => {
  const dLat = toRadians(to.latitude - from.latitude);
  const dLng = toRadians(to.longitude - from.longitude);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRadians(from.latitude)) * Math.cos(toRadians(to.latitude)) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_M * Math.asin(Math.sqrt(a));
};

export const pickupCheck = (rider, restaurant) => {
  const target = toPoint(restaurant?.latitude, restaurant?.longitude);
  if (!target) return { allowed: false, reason: "no_restaurant_location" };
  const distance = Math.round(distanceMetres(rider, target));
  return { allowed: distance <= PICKUP_RADIUS_M, distance };
};

export const dropCheck = (rider, accuracy, address) => {
  const target = toPoint(address?.latitude, address?.longitude);
  if (!target) return { withoutPin: false, reason: "no_address_location" };
  if (!Number.isFinite(accuracy) || accuracy > DROP_RADIUS_M) return { withoutPin: false, reason: "weak_signal" };
  const distance = Math.round(distanceMetres(rider, target));
  return { withoutPin: distance <= DROP_RADIUS_M, distance };
};

export const describeDistance = (metres) =>
  metres < 1000 ? `${Math.round(metres)} m` : `${(metres / 1000).toFixed(1)} km`;
